import accessDenied from "../../assets/images/accessDenied.png";
import withUser from "../../redux/HOC/withUser";

const AccessDenied = ({user, requestedURL}:any) => {
    const requestAccess = ()=>{
        let userName = user?.userName;
        let toolName = requestedURL;
        window.open(`${"mailto:StockloanDev@matrixapps.com?subject=Access Request to" } ${toolName}&body=${userName} requests access for ${toolName}` );
    }
    return (<>
        <div className="container h-100 w-100 d-flex align-items-center justify-content-center">
            <div className="text-center">
                <img style={{marginTop:'-3.5rem'}} className="center" alt="Access Denied" src={accessDenied} />
                <div style={{marginTop:'-1.5rem'}}>
                    <h2>Access Denied</h2>
                    <p>You don't have permission to view this page. Request access from your administrator.</p>
                    <button className="btn btn-primary" onClick={requestAccess}>Request Now</button>
                </div>
            </div>
        </div>
    </>)
}

export default withUser(AccessDenied);